<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center" style="gap:10px;">
        <div class="d-block">
          <div class="section-title">{{ $t("voucher") }}</div>
          <div class="section-subTitle my-2">{{
            $tc("manageAllVouchers")
          }}</div>
        </div>
        <div>
          <b-form-input
            v-debounce:300="onSearchVoucherList"
            v-model="searchValue"
            :placeholder="$tc('searchs')"
          ></b-form-input>
        </div>
      </div>

      <div class="d-flex align-items-center" style="gap:10px;">
        <div>
          <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
          <b-button
            v-if="cinema_manager_add_edit_disabled != 3"
            variant="default"
            to="add-vouchers"
            class="btn-blue"
            >{{ $t("add") }}</b-button
          >
          <!-- <b-dropdown
          :text="selectedStatus"
          variant="dropdown-curve"
          class="ml-auto mr-3"
        >
          <b-dropdown-item
            v-for="(status, statusIndex) in statuses"
            :key="statusIndex"
            v-on:click="filterStatus(status.status)"
            >{{ status.status }}</b-dropdown-item
          >
        </b-dropdown> -->
        </div>

        <div class="d-flex align-items-center">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                getVoucherList(filterIsActive);
              }
            "
          />
          <div class="mx-2">
            <b-dropdown id="listview" variant="outline-blue">
              <template v-slot:button-content>
                {{ $tc("viewing") }}&nbsp;
                <strong>{{ selectedvalue }}</strong>
                &nbsp;{{ $tc("of") }}&nbsp;
                <strong>{{ rows }}</strong>
              </template>
              <b-dropdown-item
                v-for="(list, listIndex) in viewingnumbers"
                :key="listIndex"
                @click="onDropDownChangeValue(list.name)"
                href="#"
                >{{ list.name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left">
              <span class="">{{ $tc("status", 2) }}</span>
            </th>

            <th style="width:250px;">
              <img
                v-if="this.columnName != 'voucher_title'"
                @click="onSortValue('voucher_title', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('voucher_title', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('voucher_title', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("voucher") }}
            </th>
            <th style="width:300px;">
              <img
                v-if="this.columnName != 'voucher_code'"
                @click="onSortValue('voucher_code', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('voucher_code', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('voucher_code', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("code") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'voucher_start_date_time'"
                @click="onSortValue('voucher_start_date_time', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('voucher_start_date_time', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('voucher_start_date_time', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />{{ "From" }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'voucher_end_date_time'"
                @click="onSortValue('voucher_end_date_time', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('voucher_end_date_time', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('voucher_end_date_time', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />{{ "To" }}
            </th>
            <th class="text-center">{{ $tc("type") }}</th>
            <th class="text-center">{{ $tc("No. of Vouchers") }}</th>
            <!-- <th class="text-center">{{("No.vouchers")}}</th> -->
          </tr>
        </thead>
        <tbody v-if="vocuerList && vocuerList.length > 0">
          <tr
            v-for="(voucherItem, voucherIndex) in vocuerList"
            :key="voucherIndex"
            class="light_grey_back"
          >
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <!-- <label class="ios-switch">
                  <input
                    :checked="voucherItem.voucher_is_active === 'Y'"
                    disabled
                    type="checkbox"
                    class="ios-checkbox"
                  />

                  <span class="switch-slider"></span>
                </label> -->
                <StatusDot
                  :status="
                    voucherItem.voucher_is_active == 'Y'
                      ? 'active'
                      : voucherItem.voucher_is_active == 'N' && 'inactive'
                  "
                />

                <b-dropdown right variant="edit" class="ml-2">
                  <b-dropdown-item
                    v-if="cinema_manager_add_edit_disabled != 3"
                    v-on:click="onEditVoucher(voucherItem)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewVoucher(voucherItem)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click.prevent.stop="onViewVoucherCode(voucherItem)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }} {{ $t("voucher") }} {{ $t("codes") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click.prevent.stop="onViewVoucherUsage(voucherItem)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }} {{ $t("usage") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
            <td>
              <div class="d-flex">
                <b-dropdown right variant="edit" class="mr-2" v-if="false">
                  <b-dropdown-item
                    v-if="cinema_manager_add_edit_disabled != 3"
                    v-on:click="onEditVoucher(voucherItem)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewVoucher(voucherItem)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click.prevent.stop="onViewVoucherCode(voucherItem)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }} {{ $t("voucher") }} {{ $t("codes") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click.prevent.stop="onViewVoucherUsage(voucherItem)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }} {{ $t("usage") }}
                  </b-dropdown-item>
                </b-dropdown>
                {{ voucherItem.voucher_title }}
              </div>
            </td>
            <td>{{ voucherItem.voucher_code }}</td>
            <td>{{
              moment(voucherItem.voucher_start_date_time).format("DD MMM YYYY")
            }}</td>
            <td>{{
              voucherItem.voucher_end_date_time
                ? moment(voucherItem.voucher_end_date_time).format(
                    "DD MMM YYYY"
                  )
                : "-"
            }}</td>
            <td>{{ getVoucherType(voucherItem) }}</td>
            <td class="text-right" style="padding-right:50px">{{
              voucherItem.singlevouchercount
            }}</td>
            <!-- <template
          v-for="(num,numdata) in numvoucher"
          >
              <div :key="numdata + 'new'">
                <td>
                  {{(numdata) + 1}}
                </td>
              </div>
          </template> -->
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="3">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="vocuerList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
  <!-- GRID VIEW -->

  <!-- LIST VIEW DESIGNATION -->
</template>

<script>
  import MarketingService from "@/services/MarketingService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import moment from "moment";

  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
    },
    data() {
      return {
        voucher_title: null,
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",

        vocuerList: [],
        numvoucher: [],

        gridView: false,
        listView: true,

        debounce: null,
        searchValue: "",

        //Sorting data
        isSort: false,
        isAscending: true,
        orderby: "",
        columnName: "",
        // statuses: [
        //   { status: "Active" },
        //   { status: "Inactive" },
        //   { status: "All" }
        // ],
        // selectedStatus: "Active"
      };
    },
    mounted() {
      this.voucher_title = this.$route.query.voucher_title;
      this.getVoucherList();
      // this.getNumberVoucherList();
    },
    beforeMount() {
      this.cinema_manager_add_edit_disabled = this.secureStore.get(
        "USINFO"
      ).role_id;
      this.getviewingnumber();
      // this.getNumberVoucherList();
    },
    methods: {
      moment,
      onSearchVoucherList() {
        this.currentPage = 1;
        this.getVoucherList();
      },
      getVoucherType(voucher) {
        let type = ``;
        if (
          voucher.hasOwnProperty("is_open_voucher") &&
          voucher.is_open_voucher == "Y"
        ) {
          type = "Open Voucher";
        } else if (
          voucher.hasOwnProperty("is_complemetory_ticket") &&
          voucher.is_complemetory_ticket == "Y"
        ) {
          type = "Complementory Voucher";
        } else if (
          voucher.hasOwnProperty("is_voucher_type_value") &&
          voucher.is_voucher_type_value == "Y"
        ) {
          type = "Value Voucher";
        } else if (
          voucher.voucher_get_free_ticket &&
          voucher.voucher_buy_no_of_ticket
        ) {
          type =
            "Buy " +
            voucher.voucher_buy_no_of_ticket +
            " Get " +
            voucher.voucher_get_free_ticket +
            " Free ";
        } else {
          type = "-";
        }

        return type;
      },
      // filterStatus: function(status) {
      //   this.selectedStatus = status;
      //   this.currentPage = 1;
      //   this.getVoucherList();
      // },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getVoucherList();
        } else {
          this.currentPage = event;
          this.getVoucherList();
        }
      },
      //Sort
      onSortValue(columnName, orderby) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderby = orderby;
        this.getVoucherList();
      },
      getVoucherList: function(filterIsActive = "Y") {
        this.vocuerList = [];
        let loader = this.$loading.show();

        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          columnName: this.columnName,
          orderBy: this.orderby,
          searchValue: this.searchValue,
          status: filterIsActive,
        };
        MarketingService.GetVouchers(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records && data.Records.length > 0) {
                this.vocuerList = data.Records;
                this.rows = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message || this.AdminError);
            }
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      },

      /*No. of voucher */
      // getNumberVoucherList: function () {
      //    this.numvoucher = [];
      //     let payload = {
      //       limit: this.perPage,
      //       currentPage: this.currentPage,
      //       voucher_title: this.voucher_title,
      //     };
      //     MarketingService.GetVouchersCodes(payload)
      //       .then((response) => {
      //         const { data } = response;
      //         if (data && data.status) {
      //           if (data.Records.length > 0) {
      //             this.numvoucher = data.Records;
      //             if (data.totalRows >= 10) {
      //               this.rows = data.totalRows;
      //             } else {
      //               this.rows = data.totalRows;
      //               this.selectedvalue = data.totalRows;
      //             }
      //           }
      //         } else {
      //           this.$toasted.show(data.message || this.AdminError);
      //         }
      //       })
      //       .catch(this._CatchError);
      //   },

      /* eslint-disable */
      onEditVoucher: function({ voucher_id }) {
        this.$router.push({
          path: "/marketing/edit-vouchers",
          query: { voucher_id },
        });
      },
      onViewVoucher: function({ voucher_id }) {
        this.$router.push({
          path: "/marketing/view-vouchers",
          query: { voucher_id },
        });
      },
      onViewVoucherUsage: function({ voucher_id }) {
        this.$router.push({
          path: "/marketing/view-usage-voucher",
          query: { voucher_id },
        });
      },
      onViewVoucherCode: function({ voucher_title }) {
        this.$router.push({
          path: "/marketing/view-vouchers-codes",
          query: { voucher_title },
        });
      },
      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
      // onClickEdit: function(){
      //   this.$router.push({ path: 'master/editaggregators' })
      // }
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/VouchersComponent/vouchers.vue